import type { GuidedConversationBlock, SourceLanguageCode } from '@ellie/shared';
import { BlockHeader } from '../BlockHeader';
import { NativeHint } from '../NativeHint';

interface Props {
  block: GuidedConversationBlock;
  index: number;
  nativeLanguage: SourceLanguageCode;
  pageNumber: number;
}

export function GuidedConversationPreview({ block, index, nativeLanguage, pageNumber }: Props) {
  return (
    <div className="wb-page">
      <BlockHeader block={block} index={index} />

      {/* Situation box */}
      <div className="wb-situation">
        <span className="wb-icon">{block.situation.emoji || '\u{1F4CB}'}</span>
        <div>
          <p>
            <strong>Situation:</strong> {block.situation.description}
          </p>
          <p style={{ marginTop: '0.4rem', color: 'var(--wb-text-muted)' }}>
            <em>{block.situation.descriptionNative}</em>
          </p>
        </div>
      </div>

      {/* Conversation turns */}
      <div className="wb-conversation">
        {block.turns.map((turn) => (
          <div key={turn.number} className="wb-turn">
            <div className="wb-turn-header">
              <span className="wb-turn-number">{turn.number}</span>
              <span
                className={`wb-turn-role ${turn.role === 'learner' ? 'wb-learner' : 'wb-other'}`}
              >
                {turn.roleName}
              </span>
            </div>

            {turn.isPrompt ? (
              <div className="wb-starter">
                <div className="wb-starter-label">{'\u{270F}\u{FE0F}'} Your turn</div>
                <p className="wb-line-target">{turn.lineTarget}</p>
                <NativeHint text={turn.lineNative} nativeLanguage={nativeLanguage} />
              </div>
            ) : (
              <>
                <p className="wb-line-target">{turn.lineTarget}</p>
                <NativeHint text={turn.lineNative} nativeLanguage={nativeLanguage} />
              </>
            )}
          </div>
        ))}
      </div>

      {block.tip && (
        <div className="wb-tip">
          <span className="wb-icon">{block.tip.emoji || '\u{1F4A1}'}</span>
          <p>{block.tip.text}</p>
        </div>
      )}

      <span className="wb-page-number">{pageNumber}</span>
    </div>
  );
}
